module.exports = __webpack_public_path__ + "img/04.9c4d8663.svg";